var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusVolvia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "e add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeWidth: 1.5,
    fill: "#331e11",
    stroke: "#331e11"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    x1: 30,
    y1: 16,
    x2: 2,
    y2: 16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusVolvia);
export default __webpack_public_path__ + "static/media/plusVolvia.74be26b2d47a65b46d5953154b650bfa.svg";
export { ForwardRef as ReactComponent };